<template>
  <div id="location">
    <h2>Dirección</h2>
    <iframe
      class="maps"
      src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3788.954048197124!2d-66.68577268511117!3d18.25792798756251!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDE1JzI4LjUiTiA2NsKwNDEnMDAuOSJX!5e0!3m2!1sen!2sus!4v1681265151479!5m2!1sen!2sus"
      style="border: 0;"
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'LocationSection'
}
</script>
